/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../utils/config';

export const BASESTATION_CONNECTION_URL = `${API_URL}/basestationconnection`;
